import React from "react";
import {
  Box,
  Table,
  Paper,
  styled,
  Button,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
} from "@material-ui/core";

import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import { colors } from "../../utilities/src/Colors";

import SlotManagementListController, {
  S,
  Props,
  ISlotMasterItem,
} from "./SlotManagementListController.web";

const Strings = {
  pageTitle: "Slot Management",
  noRecordFounds: "No Slot Records Found",
};

export default class SlotManagementList extends SlotManagementListController {
  constructor(props: Props) {
    super(props);
    this.state = {
      slotList: [],
      isLoading: false,
      meta: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        per_page: 20,
        next_page: null,
        prev_page: null,
      },
    } as S;
  }

  render() {
    const { slotList, isLoading } = this.state;

    return (
      <MainBoxWrapper>
        <Box className="pageWrapper" style={{ paddingTop: "10px" }}>
          <div style={webStyle.headerWrapper}>
            <PageTitle>{Strings.pageTitle}</PageTitle>
            <Button
              data-test-id="addSlotButton"
              className="addButton"
              onClick={() => this.props.navigation.navigate("SlotManagementCreate")}
            >
              Add New
            </Button>
          </div>

          <TableContainer component={Paper} className="flexItem">
            <Table style={webStyle.table} aria-label="slot management table">
              <TableHead className="stickyHeader">
                <TableRow style={{ background: "#204B9C", color: "#FFFFFF" }}>
                  <StyledHeaderCell>ID</StyledHeaderCell>
                  <StyledHeaderCell>Type</StyledHeaderCell>
                  <StyledHeaderCell>Window</StyledHeaderCell>
                  <StyledHeaderCell>Slots/Day</StyledHeaderCell>
                  <StyledHeaderCell>Threshold</StyledHeaderCell>
                  <StyledHeaderCell>No. of Regions</StyledHeaderCell>
                  <StyledHeaderCell>No. of Areas</StyledHeaderCell>
                  <StyledHeaderCell>No. of Stores</StyledHeaderCell>
                  <StyledHeaderCell>Actions</StyledHeaderCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!isLoading &&
                  slotList.map((item: ISlotMasterItem) => {
                    const attr = item.attributes;
                    return (
                      <TableRow key={item.id} data-test-id={"slot-row-" + item.id}>
                        <TableCell>{attr.id}</TableCell>
                        <TableCell style={{ textTransform: "capitalize" }}>
                          {attr.slot_type || "--"}
                        </TableCell>
                        <TableCell>
                          {attr.start_time && attr.end_time
                            ? `${attr.start_time} – ${attr.end_time}`
                            : "--"}
                          {attr.interval_minutes
                            ? ` · ${attr.interval_minutes} min`
                            : ""}
                        </TableCell>
                        <TableCell>{attr.slots_per_day ?? "--"}</TableCell>
                        <TableCell>{attr.threshold}</TableCell>
                        <TableCell>{attr.regions?.length || 0}</TableCell>
                        <TableCell>{attr.areas?.length || 0}</TableCell>
                        <TableCell>{attr.stores?.length || 0}</TableCell>
                        <TableCell>
                          <Button
                            data-test-id={"viewSlotBtn-" + item.id}
                            className="viewButton"
                            onClick={() => this.props.navigation.navigate("SlotManagementView", { id: item.id })}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>

              {isLoading && (
                <>
                  {Array(5)
                    .fill(1)
                    .map((_, index) => (
                      <TableBody key={index}>
                        <TableRow>
                          {[...Array(9)].map((_, cellIndex) => (
                            <TableRowsSkeleton key={cellIndex} />
                          ))}
                        </TableRow>
                      </TableBody>
                    ))}
                </>
              )}
            </Table>

            {slotList.length === 0 && !isLoading && (
              <NoRecordFoundText>{Strings.noRecordFounds}</NoRecordFoundText>
            )}
          </TableContainer>
        </Box>
      </MainBoxWrapper>
    );
  }
}

// Customizable Area Start
const NoRecordFoundText = styled("div")({
  fontSize: 16,
  fontWeight: 600,
  textAlign: "center",
  padding: "40px 0",
});

const PageTitle = styled("div")({
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "29px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

const StyledHeaderCell = styled(TableCell)({
  color: "#FFFFFF !important",
  fontWeight: 600,
  fontFamily: "Montserrat",
});

const MainBoxWrapper = styled("div")({
  "& .MuiTableCell-root": {
    padding: "8px 12px !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  },
  "& .MuiTableRow-root": {
    height: "48px",
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    padding: "10px 12px !important",
    fontWeight: 600,
    color: "#FFFFFF",
  },
  "& .stickyHeader": {
    zIndex: 2,
  },
  "& .addButton": {
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: colors().white,
    height: "56px",
    width: "184px",
    borderRadius: "8px",
    textTransform: "unset",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px",
      width: "160px",
      height: "44px",
    },
  },
  "& .viewButton": {
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: colors().white,
    height: "40px",
    width: "100px",
    borderRadius: "8px",
    textTransform: "unset",
  },
});

const webStyle = {
  table: {
    minWidth: 700,
  },
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 32,
    alignItems: "center",
    flexWrap: "wrap" as "wrap",
  },
};
// Customizable Area End
